import type { ReactNode } from 'react';

export const symbol_health_cross: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M357-120q-12.75 0-21.37-8.63Q327-137.25 327-150v-177H150q-12.75 0-21.37-8.63Q120-344.25 120-357v-247q0-12.75 8.63-21.38Q137.25-634 150-634h177v-176q0-12.75 8.63-21.38Q344.25-840 357-840h247q12.75 0 21.38 8.62Q634-822.75 634-810v176h176q12.75 0 21.38 8.62Q840-616.75 840-604v247q0 12.75-8.62 21.37Q822.75-327 810-327H634v177q0 12.75-8.62 21.37Q616.75-120 604-120H357Zm30-60h187v-207h206v-187H574v-206H387v206H180v187h207v207Zm93-300Z"
		/>
	</svg>
);
